import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';
import img1 from 'assets/images/img1cropped.png';
import style from './style.module.scss';
import { SeoMeta } from '../../components/SeoMeta/SeoMeta';

import heroBgWebp from 'assets/images/BackgroundHeader.webp';

export const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <SeoMeta
        title="Planoo - Smarter Property Search"
        description="Find your dream property with ease on Planoo. Simplify your real estate search today."
        canonical="https://planoo.com.au/"
        url="https://planoo.com.au/"
        preloadImage={heroBgWebp}
        fetchPriority="high"
      />
      <div className={style.above_the_fold}>
        <div className={style.heroBg} aria-hidden="true">
          <img
            src={heroBgWebp}
            alt=""
            loading="eager"
            {...({ fetchpriority: 'high' } as any)}
            decoding="async"
            width="1920"
            height="1080"
          />
        </div>
        <div className={style.overlay} aria-hidden="true" />

        <div className={style.hero_content}>
          <h2 className={style.hero_subtitle}>
            Find a Home That Fits Your Commute.
          </h2>
          <p className={style.hero_description}>
            Compare travel times to work, school, or family before you waste
            weekends on inspections.
          </p>
          <Button
            variant="contained"
            color="success"
            onClick={() => navigate('/app')}
            className={style.hero_button}
            sx={{
              textTransform: 'none',
              fontSize: '1.1rem',
              fontWeight: 600,
              px: { xs: 4, sm: 6 },
              py: { xs: 1.5, sm: 2 },
              borderRadius: '12px',
              boxShadow: '0 4px 14px 0 rgba(0,155,72,0.39)',
            }}
          >
            See Your Commute Now
          </Button>
        </div>
      </div>

      <div className={style.content}>
        <div className={style.row_2_cols}>
          <picture>
            <img
              height="auto"
              width="100%"
              src={img1}
              alt="Modern home"
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div>
            <h2 className={style.big_title}>Find the right home, faster.</h2>
            <h4 style={{ maxWidth: '45ch' }}>
              Focus on your lifestyle, not just the listings.
            </h4>
            <p>
              Planoo is your personal shortlist manager. Instead of jumping
              between real estate sites and maps, simply save the properties
              you’re considering and compare travel times to the places that
              matter most to you.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
